import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-employee-dashboard',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './employee-dashboard.component.html',
  styleUrl: './employee-dashboard.component.scss'
})
export class EmployeeDashboardComponent {

  startDate: string = '';
  endDate: string = '';

  stats = [
    { title: 'Active Employees', value: 1284, icon: 'bi bi-people text-success', trend: '+12%', trendClass: 'text-success', buttonClass: 'btn btn-outline-success' },
    { title: 'Left Employees', value: 42, icon: 'bi bi-box-arrow-right text-danger', trend: '-2%', trendClass: 'text-danger', buttonClass: 'btn btn-outline-danger' },
    { title: 'Pending Onboarding', value: 156, icon: 'bi bi-clock text-muted', trend: '5d avg', trendClass: 'text-muted', buttonClass: 'btn btn-outline-secondary' },
    { title: 'Accepted Offers', value: 84, icon: 'bi bi-check-circle text-success', trend: '88%', trendClass: 'text-success', buttonClass: 'btn btn-outline-success' },
    { title: 'Rejected', value: 12, icon: 'bi bi-x-circle text-danger', trend: '-4%', trendClass: 'text-danger', buttonClass: 'btn btn-outline-danger' }
  ];

  funnel = [
    { step: 1, label: 'Initiated', count: '240 Leads', class: 'bg-primary' },
    { step: 2, label: 'Pending', count: '156 Docs', class: 'bg-info' },
    { step: 3, label: 'Approved', count: '92 Ready', class: 'bg-secondary' },
    { step: '✕', label: 'Rejected', count: '12 Failed', class: 'bg-danger' },
    { step: '✓', label: 'Completed', count: '48 Joined', class: 'bg-success' }
  ];

  employees = [
    {
      name: 'Amit Sharma',
      id: 'EID-9201',
      role: 'Software Eng.',
      branch: 'Mumbai HQ',
      status: 'Pending',
      date: 'Oct 24, 2023',
      avatar: 'https://i.pravatar.cc/40'
    },
    {
      name: 'Priya Kapur',
      id: 'EID-9204',
      role: 'HR Specialist',
      branch: 'Bangalore',
      status: 'Completed',
      date: 'Oct 22, 2023',
      avatar: 'https://i.pravatar.cc/41'
    },
    {
      name: 'Rahul Verma',
      id: 'EID-9208',
      role: 'Product Manager',
      branch: 'Delhi NCR',
      status: 'In Progress',
      date: 'Oct 21, 2023',
      avatar: 'https://i.pravatar.cc/42'
    }
  ];

  actions = [
    { label: 'Add Employee', icon: 'bi bi-person-plus' },
    { label: 'Bulk Upload', icon: 'bi bi-cloud-upload' },
    { label: 'Export Reports', icon: 'bi bi-download' },
    { label: 'Configure', icon: 'bi bi-gear' }
  ];

  alerts = [
    { title: '12 Pending Approvals', desc: 'Overdue for 48 hours', class: 'alert-danger' },
    { title: 'Missing Documents', desc: '8 employees pending', class: 'alert-warning' },
    { title: 'Onboarding Delay', desc: 'IT setup pending', class: 'alert-success' }
  ];

  ages = [
    { label: '0-17 years', value: 0 },
    { label: '18-25 years', value: 42 },
    { label: '26-33 years', value: 35 },
    { label: '34-41 years', value: 15 },
    { label: '42+ years', value: 8 }
  ];

}
